import { render, staticRenderFns } from "./tabPage.vue?vue&type=template&id=14354210&scoped=true&"
import script from "./tabPage.vue?vue&type=script&lang=js&"
export * from "./tabPage.vue?vue&type=script&lang=js&"
import style0 from "./tabPage.vue?vue&type=style&index=0&id=14354210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14354210",
  null
  
)

export default component.exports